export enum TransactionCodeEnum {
  ok = 200,
  notFound = 404,
  server = 500,
  unauthorized = 401,
  badRequest = 400
}
